import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import LiveColumns from "./component";

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === "Columns") {
    return [LiveColumns];
  }
};
